module.exports = __webpack_public_path__ + "static/img/20230428_03.4e5c174.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2023/20230428_03.png
// module id = jLwK
// module chunks = 0